import { render, staticRenderFns } from "./UPCConsumerBlockReport.vue?vue&type=template&id=35c315ec"
import script from "./UPCConsumerBlockReport.vue?vue&type=script&lang=js"
export * from "./UPCConsumerBlockReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports